import React, { useEffect, useState } from "react";
import Parse from "parse";
import { Button, IconButton, Input, Snackbar, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";

import "./ICalGeneratorComponent.css";

const ICalGeneratorComponent = () => {
  const [iCalLink, setICalLink] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const generateICalToken = () => Parse.Cloud.run("generateCalendarToken");
  const generateICalLink = async function () {
    return `https://app.desda.org/api/v2/calendar.ics?token=${await generateICalToken()}`;
  };

  return (
    <div id="ical-parent">
      <Input
        placeholder="Klik op de knop rechts om een iCal link te genereren..."
        className="ical-link-field"
        value={iCalLink}
      />
      <Button
        type="button"
        color="primary"
        variant="contained"
        onClick={async function () {
          generateICalLink().then((l) => setICalLink(l));
        }}
      >
        <Typography>Genereer Link</Typography>
      </Button>
      <IconButton
        disabled={!iCalLink}
        onClick={() => {
          navigator.clipboard.writeText(iCalLink);
          setSnackbarOpen(true);
        }}
      >
        <ContentCopyIcon />
      </IconButton>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => {
          setSnackbarOpen(false);
        }}
        message={<span id="message-id">Link gekopieerd naar het klembord</span>}
        action={
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            style={{ padding: "4px" }}
            onClick={() => {
              setSnackbarOpen(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        }
      />{" "}
    </div>
  );
};

export default ICalGeneratorComponent;
